import { useState } from "react"
import cn from "classnames"

import { useHasJS } from "@hooks"

import styles from "./Faqs.module.scss"

const Faqs = ({ data }) => {
  const [openItems, setOpenItems] = useState([])
  const hasJS = useHasJS()

  const handleClick = (i) => {
    if (openItems.includes(i)) {
      setOpenItems(openItems.filter((item) => item !== i))
    } else {
      setOpenItems([...openItems, i])
    }
  }

  const shouldShowAnswer = (i) => (hasJS ? openItems.includes(i) : true)

  if (!data || data.length === 0) {
    return null
  }

  return (
    <div className={styles.container}>
      {data?.map((faq, i) => {
        return (
          <div
            key={i}
            className={cn({ [styles.faq]: true, [styles.faqBorder]: i !== 0 })}
          >
            <div className={styles.title} onClick={() => handleClick(i)}>
              <h3>{faq.question}</h3>
              <img
                src={
                  openItems.includes(i)
                    ? "/landing/minus.svg"
                    : "/landing/plus-green.svg"
                }
                alt={
                  openItems.includes(i) ? "Green minus icon" : "Green plus icon"
                }
              />
            </div>
            {shouldShowAnswer(i) && (
              <div
                className={styles.answer}
                dangerouslySetInnerHTML={{ __html: faq.answer }}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default Faqs
